import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-pressed", "aria-label", "title"]
const _hoisted_2 = { class: "toggle-label" }

import { ToggleLeft, ToggleRight } from "lucide-vue-next";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewToggle',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isEditor = computed(() => route.name === "Editor");
const isRecord = computed(() => route.name === "Records");
const isTelemetry = computed(() => route.name === "Track");
const deviceId = computed(() => route.params.deviceId);

// Testo dinamico
const targetName = computed(() =>
  isEditor.value || isRecord.value || isTelemetry.value ? "Data" : "Editor"
);
const text = computed(() =>
  isEditor.value || isRecord.value || isTelemetry.value ? "Vai ai" : "Vai all'"
);
const ctaText = computed(() => `${text.value} ${targetName.value}`);

function toggle() {
  router.push({ name: targetName.value, params: { deviceId: deviceId.value } });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["icon-toggle", { 'on-telemetry': isTelemetry.value }]),
    "aria-pressed": isEditor.value ? 'true' : 'false',
    "aria-label": ctaText.value,
    title: ctaText.value,
    onClick: toggle
  }, [
    (isEditor.value)
      ? (_openBlock(), _createBlock(_unref(ToggleLeft), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(ToggleRight), { key: 1 })),
    _createElementVNode("span", _hoisted_2, _toDisplayString(ctaText.value), 1)
  ], 10, _hoisted_1))
}
}

})